class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
let allSearchForms = [];
    this.allSearchInputs.forEach((input) => {
      allSearchForms.push(input.form);
      input.addEventListener('input', this.onInput.bind(this));
      input.addEventListener('blur', this.onBlur.bind(this)); // ✅ Added blur handler
    });
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => {
    form.addEventListener('submit', this.onFormSubmit.bind(this)); // ✅ add this
    form.addEventListener('reset', this.onFormReset.bind(this));
    });
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

onBlur(event) {
  const target = event.target;

  const sanitizedValue = target.value
    .replace(/\s+x\s+/gi, 'x')
    .replace(/\s+mm\s+/gi, 'mm ')
    .trim();

  target.value = sanitizedValue;
  this.keepInSync(sanitizedValue, target);
}

onFormSubmit(event) {
  const form = event.target;
  const input = form.querySelector('input[type="search"]');

  if (!input) return;

  const sanitizedValue = input.value
    .replace(/\s+x\s+/gi, 'x')
    .replace(/\s+mm\s+/gi, 'mm ')
    .trim();

  input.value = sanitizedValue;
  this.keepInSync(sanitizedValue, input);
}  
  

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
